<template>
  <div class="form">
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="form.brandSelected"
          @setBrand="setBrand"
          @setBrands="setBrands"
          style="margin-top: 0.6rem"
          required="true"
          :setDisable="!!$route.query.id"
        ></BrandDropdown>
        <div v-if="isSubmit && error.errorBrand" class="text-error">
          {{ error.errorBrand.message }}
        </div>
      </div>
      <div class="col-4 date-crm">
        <label for="dateSelected" required>Date</label>
        <date-picker
          id="dateSelected"
          v-bind="$attrs"
          v-model="form.dateSelect"
          format="D MMMM yyyy"
          lang="en"
          :value="form.dateSelect"
          @change="form.dateSelect = $event"
          :setDisable="!!$route.query.id"
        />
        <div v-if="isSubmit && error.errorDate" class="text-error">
          {{ error.errorDate.message }}
        </div>
      </div>
      <div class="col-4 align-self-center pt-12 pl-14">
        <div class="d-flex flex-row">
          <input
            class="form-check-input mr-2"
            id="isIncludeV"
            type="checkbox"
            v-model="form.isIncludeVVIP"
            :disabled="!!$route.query.id"
          />
          <label class="form-check-label" for="isIncludeV"> Include V </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label for="selectedChannel" required>Channel</label>
        <multiselect
          id="selectedChannel"
          v-model="form.selectedChannel"
          :options="channels"
          :preserve-search="true"
          label="text"
          track-by="key"
          placeholder="เลือก Customer Channel"
          style="margin-top: 0.6rem"
          @input="setChannel"
          @close="validateSources"
          :disabled="!!$route.query.id"
        >
        </multiselect>
        <div v-if="isSubmit && error.errorChannel" class="text-error">
          {{ error.errorChannel.message }}
        </div>
      </div>
      <div class="col-6">
        <label for="selectedSources" required>Sources</label>
        <multiselect
          id="selectedSources"
          v-model="form.selectedSources"
          :options="sources"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          label="text"
          track-by="key"
          placeholder="เลือก Sources"
          style="margin-top: 0.6rem"
          @close="validateSources"
          @remove="validateSources"
          :disabled="!!$route.query.id"
        >
          <template slot="tag" slot-scope="{ option }" v-if="option.disabled">
            <span class="multiselect__tag">
              {{ option.text }}
            </span>
          </template>
        </multiselect>
        <div v-if="isSubmit && error.errorSources" class="text-error">
          {{ error.errorSources.message }}
        </div>
        <div v-show="validateOnlineSourceMessage" class="text-error">
          {{ validateOnlineSourceMessage }}
        </div>
      </div>
      <div class="button-group pt-5" v-if="isShowOkButton">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="filterMetricData"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import BrandDropdown from "components/Brand/BrandDropdown.vue";
import moment from "moment/moment";
import ReportService from "services/api/report.service";
import BrandService from "services/api/brand.service";

export default {
  components: { BrandDropdown },
  props: {
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Object,
      default: () => {},
    },
    isShowOkButton: {
      type: Boolean,
      default: () => false,
    },
    filteredData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      channels: [],
      sources: [],
      brandOptions: [],
      validateOnlineSourceMessage: null,
      form: {
        brandSelected: null,
        dateSelect: moment().format("YYYY-MM-DD"),
        isIncludeVVIP: false,
        selectedChannel: null,
        selectedSources: [],
      },
    };
  },
  mounted() {
    this.getSourcesByChannels();
  },
  watch: {
    async filteredData(newVal) {
      await this.getBrands();
      this.form.brandSelected = this.brandOptions.find(
        (b) => b.id === newVal.brand
      );
      this.form.dateSelect = newVal.date;
      this.form.isIncludeVVIP = newVal.isIncludeVVIP;
      this.form.selectedChannel = this.channels.find(
        (c) => c.key === newVal.channel
      );
      const filteredSourceKeys = newVal.sources.split(",");
      this.form.selectedSources = this.sources.filter((s) =>
        filteredSourceKeys.find((f) => f === s.key)
      );
    },
  },
  methods: {
    filterMetricData() {
      this.validateSources();
      if (this.validateOnlineSourceMessage) {
        return;
      }
      this.$emit("filterMetrics", this.form);
    },
    async getBrands() {
      try {
        const res = await BrandService.getListBrands();
        const data = await res.data;
        this.brandOptions = data.brand.map((s) => {
          return {
            id: s.code,
            text: s.name,
          };
        });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    async getSourcesByChannels() {
      await ReportService.getChannelsAndSources()
        .then((res) => {
          const data = res.data;
          this.channels = data.channels;
          this.sources = data.sources;
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    setChannel() {
      this.form.selectedSources = [];
      this.validateOnlineSourceMessage = null;

      let offlineSourceList = this.sources.filter((s) => s.type === "OFFLINE");
      let onlineSourceList = this.sources.filter((s) => s.type === "ONLINE");

      this.handleSourceSelection(
        offlineSourceList,
        this.form.selectedChannel?.minimumRequiredOffline,
        this.form.selectedChannel?.selectAllowedOffline
      );

      this.handleSourceSelection(
        onlineSourceList,
        this.form.selectedChannel?.minimumRequiredOnline,
        this.form.selectedChannel?.selectAllowedOnline
      );

      this.sources = this.sources.map((source) => {
        delete source.$isDisabled;
        let isAutoSelectedSource = this.form.selectedSources.some(
          (s) => s.key === source.key && s.disabled === true
        );
        if (isAutoSelectedSource) {
          return { ...source, $isDisabled: true };
        }
        if (
          this.form.selectedChannel?.selectAllowedOffline === false &&
          source.type === "OFFLINE"
        ) {
          return { ...source, $isDisabled: true };
        }
        if (
          this.form.selectedChannel?.selectAllowedOnline === false &&
          source.type === "ONLINE"
        ) {
          return { ...source, $isDisabled: true };
        }
        return source;
      });
    },
    handleSourceSelection(sourceList, requiredCount, selectionAllowed) {
      if (requiredCount > 0 && selectionAllowed === true) {
        sourceList.map((source) => {
          if (requiredCount === sourceList.length) {
            this.form.selectedSources.push({ ...source, disabled: true });
          } else {
            this.form.selectedSources.push(source);
          }
        });
      }
    },
    validateSources() {
      if (
        this.isSourceValidationFailed(
          this.form.selectedChannel?.minimumRequiredOffline,
          this.form.selectedChannel?.selectAllowedOffline,
          "OFFLINE"
        ) ||
        this.isSourceValidationFailed(
          this.form.selectedChannel?.minimumRequiredOnline,
          this.form.selectedChannel?.selectAllowedOnline,
          "ONLINE"
        )
      ) {
        this.validateOnlineSourceMessage =
          "Please select at least one online source";
      } else {
        this.validateOnlineSourceMessage = null;
      }
    },
    isSourceValidationFailed(minimumRequired, selectAllowed, type) {
      const isSourceSelected = this.form.selectedSources.some(
        (s) => s.type === type
      );
      return minimumRequired > 0 && selectAllowed && !isSourceSelected;
    },
    setBrand(brand) {
      this.form.brandSelected = brand || "";
    },
    setBrands(brands) {
      brands?.forEach((brand) => {
        if (brand.id === this.form.brandSelected) {
          this.form.brandSelected = brand;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

label[required]::after {
  content: "*";
  color: red;
  margin-left: 5px;
}
</style>
